/**
 * Environment Variables Setup
 * Sets up environment variables for Stripe and other services
 * Note: Supabase client is now initialized by shared/src/auth/init-supabase-auth.js
 */

export function initializeSupabase() {
  // Load credentials from Vite environment variables (set in .env / .env.local)
  const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL || '';
  const supabaseKey = import.meta.env?.VITE_SUPABASE_ANON_KEY || '';
  const stripeKey = import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY || '';

  if (!supabaseUrl || !supabaseKey) {
    console.error('⚠️ Missing Supabase environment variables. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env');
  }

  // Note: window.supabaseClient is created by shared auth (init-supabase-auth.js)
  // We just set up ENV variables for Stripe and other services that need them
  window.ENV = {
    VITE_SUPABASE_URL: supabaseUrl,
    VITE_SUPABASE_ANON_KEY: supabaseKey,
    VITE_STRIPE_PUBLISHABLE_KEY: stripeKey
  };

  console.log('✅ Environment variables configured');
  console.log('ℹ️  Supabase client managed by shared auth package');
}
